export default {
      id: "pointer-click-usage",
      viewBox: "0 0 592.875 592.875",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#pointer-click-usage",
      toString: function () {
        return this.url;
      }
    }